import { applyMiddleware, createStore, compose } from 'redux'
import thunk from 'redux-thunk'

// need to do is this way so that the dev store will work with browsers other than Chrome
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const middlewares = applyMiddleware(thunk)
const enhancers = composeEnhancers(
    middlewares
)

export default function (reducer, initialState) {
    return createStore(reducer, initialState, enhancers)
}



// WEBPACK FOOTER //
// ./react/store/createStore.dev.js